import { DEFAULT_ZONE_OPTIONS } from "./zoneShared";
import { detectHiddenZones } from "./hiddenZoneEngine";
import { detectDemandZones } from "./demandZoneEngine";
import { detectSupplyZones } from "./supplyZoneEngine";

function sortZonesByPriority(zones = []) {
  const stateWeight = {
    fresh: 3,
    tested: 2,
    failed: 1,
  };

  return [...zones].sort((left, right) => {
    const leftWeight = stateWeight[left.state] ?? 0;
    const rightWeight = stateWeight[right.state] ?? 0;

    if (leftWeight !== rightWeight) {
      return rightWeight - leftWeight;
    }

    if ((right.qualityScore ?? 0) !== (left.qualityScore ?? 0)) {
      return (right.qualityScore ?? 0) - (left.qualityScore ?? 0);
    }

    if ((right.impulseDistance ?? 0) !== (left.impulseDistance ?? 0)) {
      return (right.impulseDistance ?? 0) - (left.impulseDistance ?? 0);
    }

    return (right.breakoutTime ?? 0) - (left.breakoutTime ?? 0);
  });
}

function keepFailedZonesVisible(zones = [], maxZonesPerType) {
  const activeZones = zones.filter((zone) => zone?.state !== "failed");
  const failedZones = zones.filter((zone) => zone?.state === "failed");

  return [...activeZones.slice(0, maxZonesPerType), ...failedZones];
}

export function detectSupplyDemandZones(candles, market, options = {}) {
  const hidden = detectHiddenZones(candles, options);
  const demand = detectDemandZones(candles, options);
  const supply = detectSupplyZones(candles, options);
  const resolvedOptions = {
    ...DEFAULT_ZONE_OPTIONS,
    ...options,
  };
  const directionalZones =
    market === "CRASH"
      ? sortZonesByPriority(supply.zones)
      : sortZonesByPriority(demand.zones);
  const visibleZones = keepFailedZonesVisible(
    directionalZones,
    resolvedOptions.maxZonesPerType
  );
  const directionalDemandZones = keepFailedZonesVisible(
    sortZonesByPriority(demand.zones),
    resolvedOptions.maxZonesPerType
  );
  const directionalSupplyZones = keepFailedZonesVisible(
    sortZonesByPriority(supply.zones),
    resolvedOptions.maxZonesPerType
  );

  return {
    hiddenZones: hidden.zones,
    demandZones: directionalDemandZones,
    supplyZones: directionalSupplyZones,
    zones: visibleZones,
    analyzedCount: Math.max(
      hidden.analyzedCount,
      demand.analyzedCount,
      supply.analyzedCount
    ),
    averageCandleRange:
      demand.averageCandleRange ||
      supply.averageCandleRange ||
      hidden.averageCandleRange ||
      0,
    options: resolvedOptions,
  };
}

export {
  DEFAULT_ZONE_OPTIONS,
  detectHiddenZones,
  detectDemandZones,
  detectSupplyZones,
};
